import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, RouterStateSnapshot, UrlSegment, Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanLoad {

  constructor( 
    private router: Router ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        if ( !localStorage.getItem('token') ) {
            this.router.navigate(['']);
        }else{
          this.router.events.forEach((event) => {
            if (event instanceof NavigationEnd) {
              if(event.url.toString() == "/pdg"){
                this.router.navigate(['/pdg/home']);
              }
            }
          });
        }
        let token = localStorage.getItem('token')
        let listPermis = jwt_decode(token);
    
    
        let initHome = true;
        if(route.data["role"] != null){

          for(let infoData of route.data["role"]){
            let info = listPermis['permisses'].filter( n =>  n == infoData)
            if(info[0] == null){
              initHome = false;
            }
            if(info[0] != null){
              initHome = true;
              break;
            }

          }
        }
        if(!initHome){
          this.router.navigate(['/pdg/home']);
        }
        this.router.events.forEach((event) => {
          if (event instanceof NavigationEnd) {
            if(!event.url.toString().includes("/pdg/home")){
              if(listPermis['permisses'][0] == null){
                   this.router.navigate(['/pdg/home']);
              }else{

              }
            }
          }
        });

   
      return true;

  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | boolean {
      
        if ( !localStorage.getItem('token') ) {
            this.router.navigate(['']);
        }else{
          this.router.events.forEach((event) => {
            if (event instanceof NavigationEnd) {
              if(event.url.toString() == "/pdg"){
                this.router.navigate(['/pdg/home']);
              }
            }
          });
        }

        return true;

  }
}
